;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.creditnote', [
      'kilo.routes.creditnote.list',
      'kilo.routes.creditnote.show'
    ])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {
    var parentState = {
      name: 'creditnote',
      url: '/creditnote',
      resolve: {},
      abstract: true,
      ncyBreadcrumb: {
        label: 'Avoirs'
      }
    }

    $stateProvider.state(parentState)
  }
})(window.angular)
